import { AllController } from './all.controller'

function all () {
  return {
    scope: {
      modalState: '<',
      allowedAssetExtensionsSelection: '<',
      singleAttach: '<',
      showOnlyExtension: '<',
      removeExtensions: '<'
    },
    restrict: 'E',
    templateUrl: '/repository/directives/all/all.html?$$REVISION$$',
    controller: AllController
  }
}

export { all }
